import * as ActionTypes from "../action-types";

import { ALARM_TYPE_STATUS } from "../../../constants/template/status";

const vehicleEventLog_defaultState = {
    byID: {},
    logByVID: {},
    allIDs: [],
    selectedData: {}
}

export const vehicleEventLogs = (
    state = vehicleEventLog_defaultState,
    action
) => {
    let newState = JSON.parse(JSON.stringify(state));

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.CLEAR_TIMEFRAME_VEHICLE_EVENT_LOGS: {

            newState.byID = {}
            newState.logByVID = {}
            newState.allIDs = []

            return newState
        }
        case ActionTypes.GET_TIMEFRAME_VEHICLE_EVENT_LOGS: {

            const vehicleEventLogs = action.vehicleEventLogs

            const vid = action.vid
            const startTime = action.startTime
            const endTime = action.endTIme

            if (vid) {
                newState.byID[vid] = [startTime, endTime]

                const newVehicleEventLogs = vehicleEventLogs.map(vel => {
                    const code_name = vel.eventid.includes('cms') && vel.eventid.split('#')[2]

                    const rule = vel.eventid.includes('cms') && {
                        ruleid: vel.eventid,
                        name: vel.rule?.name || ALARM_TYPE_STATUS[code_name],
                        type_rule: vel.rule?.type_rule,
                        name_violated: null,
                        status: 1
                    }

                    return {
                        rule: rule,
                        vid: vid,
                        type_rule: vel.rule?.type_rule,
                        ...vel
                    }
                })

                newState.logByVID[vid] = newVehicleEventLogs.sort((a,b) => a.vehicleTime-b.vehicleTime)
                
                if(!newState.allIDs.includes(vid)) newState.allIDs.push(vid)
            } else {
                // Group by vel.vid for batch fetches
                const logsByVid = {}
                vehicleEventLogs.forEach(vel => {
                    const eventVid = vel.vid
                    if (!eventVid) return
                    if (!logsByVid[eventVid]) {
                        logsByVid[eventVid] = []
                    }
                    const code_name = vel.eventid.includes('cms') && vel.eventid.split('#')[2]
                    const rule = vel.eventid.includes('cms') && {
                        ruleid: vel.eventid,
                        name: vel.rule?.name || ALARM_TYPE_STATUS[code_name],
                        type_rule: vel.rule?.type_rule,
                        name_violated: null,
                        status: 1
                    }
                    logsByVid[eventVid].push({
                        rule,
                        vid: eventVid,
                        type_rule: vel.rule?.type_rule,
                        ...vel
                    })
                })

                Object.keys(logsByVid).forEach(eventVid => {
                    newState.logByVID[eventVid] = logsByVid[eventVid].sort((a, b) => a.vehicleTime - b.vehicleTime)
                    if (!newState.allIDs.includes(eventVid)) newState.allIDs.push(eventVid)
                })
            }
            
            return newState;
        }
        // case ActionTypes.GET_NOTIFICATION_THRU_WS: {
        //     const notification = action.notification
        //     const vid = notification.vid

        //     // console.log(notification)

        //     if(vid && !newState.logByVID[vid]){
        //         newState.logByVID[vid] = []
        //     }

        //     if(typeof notification === 'object' && notification !== null) {
        //         newState.logByVID[vid] = [ ...newState.logByVID[vid], notification ]
        //     }

        //     return newState            
        // }
        case ActionTypes.UPDATE_VEHICLE_EVENT_LOG: {

            const eventLog = action.eventLog
            const vid = eventLog.vid

            newState.logByVID[vid] = !newState.logByVID[vid] ? [ eventLog ] : [ ...newState.logByVID[vid], eventLog ]

            // make sure no duplicated data. if using map to replace, it's duplicated
            let data = {}

            newState.logByVID[vid]?.length && newState.logByVID[vid]?.map(event => {
                data[event.eventid] = event
            })

            newState.logByVID[vid] = Object.values(data).sort((a,b) => a.vehicleTime-b.vehicleTime)

            if(!newState.allIDs.includes(vid)) newState.allIDs.push(vid)

            return newState
        }
        case ActionTypes.CLEAR_VEHICLE_EVENT_LOG: {

            newState.logByVID = {}

            return newState;
        }
        case ActionTypes.SET_SELECTED_EVENT_LOG_VID: {
            const data = action.data

            newState.selectedData = data

            return newState
        }
        case ActionTypes.UNSET_SELECTED_EVENT_LOG_VID: {

            newState.selectedData = {}

            return newState
        }

        default: {
            return state;
        }
    }
};
